import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ shiftParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `shift/GetSearched`,
      params: shiftParams,
    });
    const allShift = data;
    yield put(Actions.setAll({ allShift }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* setIsDisabled({ rowId, isDisabled }) {
  try {
    yield call(api.put, {
      route: `shift/SetIsDisabled/${rowId}/${isDisabled}`,
    });
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateShift({ shiftData, actionName, shiftParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.post, {
      route: `shift/GetValidateShift`,
      data: shiftData,
    });
    const shiftCheck = data;
    if (shiftCheck) {
      notification('error', CONSTANT_VARIABLES.SHIFT_EXISTED, '');
      yield put(Actions.fetchAll({ shiftParams }));
    } else {
      yield call(actionName === 'Update' ? api.put : api.post, {
        route: `shift`,
        data: shiftData,
      });
      yield put(Actions.fetchAll({ shiftParams }));
      notification(
        'success',
        actionName === CONSTANT_VARIABLES.ADD ? CONSTANT_VARIABLES.SHIFT_CREATED : CONSTANT_VARIABLES.SHIFT_UPDATED,
        ''
      );
    }
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteShift({ id, shiftParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `shift/${id}`,
    });
    yield put(Actions.fetchAll({ shiftParams }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchFactoryShifts({ factoryId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `shift/getShiftbyFactoryId/${factoryId}`,
    });
    const factoryShifts = data;
    yield put(Actions.setShiftsByFactoryId({ factoryShifts }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchFactoryShiftByTimeRange({ shiftParams }) {
  try {
    if (shiftParams.factoryId > 0) {
      const { data } = yield call(api.get, {
        route: `FactoryShift/GetFactoryshiftByTimeRange/${shiftParams.factoryId}/${shiftParams.fromTime}/${shiftParams.toTime}`,
      });
      const factoryShift = data;
      yield put(Actions.setFactoryShiftByTimeRange({ factoryShift }));
    }
  } catch (error) {
    console.warn(error); // Handle exception
  }
}

function* fetchEquipmentShift({ equipmentShiftParams }) {
  try {
    yield put(Actions.setLoaderEquipmentShift({ showEquipmentShiftLoader: true }));
    const { data } = yield call(api.get, {
      route: `equipmentshift/GetEquipmentShift/${equipmentShiftParams.equipId}/${equipmentShiftParams.date}/${
        equipmentShiftParams.shiftId ? equipmentShiftParams.shiftId : null
      }`,
    });
    const equipmentShift = data;
    yield put(Actions.setEquipmentShift({ equipmentShift }));
    yield put(Actions.setLoaderEquipmentShift({ showEquipmentShiftLoader: false }));
  } catch (err) {
    yield put(Actions.setEquipmentShiftLoader({ showEquipmentShiftLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchShiftsByJobEquipmentId({ jobEquipmentId }) {
  try {
    yield put(Actions.setLoaderEquipmentShift({ showEquipmentShiftLoader: true }));
    const { data } = yield call(api.get, {
      route: `OEE/GetOeeShiftByJobEquipmentId/${jobEquipmentId}`,
    });
    const equipmentShiftById = data;
    yield put(Actions.setEquipmentShiftById({ equipmentShiftById, jobEquipmentId }));
    yield put(Actions.setLoaderEquipmentShift({ showEquipmentShiftLoader: false }));
  } catch (err) {
    yield put(Actions.setEquipmentShiftLoader({ showEquipmentShiftLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchJobEquipmentShiftsByJobId({ jobId, callback }) {
  try {
    yield put(Actions.setLoaderEquipmentShift({ showEquipmentShiftLoader: true }));
    const { data } = yield call(api.get, {
      route: `equipmentshift/jobEquipmentShifts/${jobId}`,
    });
    const jobEquipmentShiftsData = data;
    yield put(Actions.setJobEquipmentShiftsByJobId({ jobEquipmentShiftsData }));
    yield put(Actions.setLoaderEquipmentShift({ showEquipmentShiftLoader: false }));

    if (callback) {
      callback(data.toJS());
    }
  } catch (err) {
    yield put(Actions.setLoaderEquipmentShift({ showEquipmentShiftLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchLineJobEquipmentShiftsByLineJobId({ lineJobId, callback }) {
  try {
    yield put(Actions.setLoaderEquipmentShift({ showEquipmentShiftLoader: true }));
    const { data } = yield call(api.get, {
      route: `equipmentshift/lineJobEquipmentShifts/${lineJobId}`,
    });
    const lineJobEquipmentShiftsData = data;
    yield put(Actions.setLineJobEquipmentShiftsByLineJobId({ lineJobEquipmentShiftsData }));
    yield put(Actions.setLoaderEquipmentShift({ showEquipmentShiftLoader: false }));

    if (callback) {
      callback(data.toJS());
    }
  } catch (err) {
    yield put(Actions.setLoaderEquipmentShift({ showEquipmentShiftLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchFactoryCurrentShiftByFactoryId({ factoryId }) {
  try {
    if (factoryId > 0) {
      const { data } = yield call(api.get, {
        route: `FactoryShift/currentshift/${factoryId}`,
      });
      const factoryCurrentShift = data;
      yield put(Actions.setFactoryCurrentShiftByFactoryId({ factoryCurrentShift }));
    }
  } catch (error) {
    console.warn(error); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.SET_IS_DISABLED, setIsDisabled),
    takeLatest(ActionTypes.ADD_OR_UPDATE_SHIFT, addorUpdateShift),
    takeLatest(ActionTypes.DELETE_SHIFT, deleteShift),
    takeLatest(ActionTypes.FETCH_SHIFTS_BY_FACTORY_ID, fetchFactoryShifts),
    takeLatest(ActionTypes.FETCH_EQUIPMENT_SHIFT, fetchEquipmentShift),
    takeLatest(ActionTypes.FETCH_SHIFTS_BY_JOB_EQUIPMENT_ID, fetchShiftsByJobEquipmentId),
    takeLatest(ActionTypes.FETCH_FACTORY_SHIFT_BY_TIME_RANGE, fetchFactoryShiftByTimeRange),
    takeLatest(ActionTypes.FETCH_JOB_EQUIPMENT_SHIFTS_BY_JOB_ID, fetchJobEquipmentShiftsByJobId),
    takeLatest(ActionTypes.FETCH_LINE_JOB_EQUIPMENT_SHIFTS_BY_LINE_JOB_ID, fetchLineJobEquipmentShiftsByLineJobId),
    takeLatest(ActionTypes.FETCH_FACTORY_CURRENT_SHIFT_BY_FACTORY_ID, fetchFactoryCurrentShiftByFactoryId),
  ]);
}
